<template>
    <DsTooltip
        v-if="tooltipText"
        :tooltipText="tooltipText"
        tooltipLocation="top"
    >
        <TagCore
            :text
            :variant
        />
    </DsTooltip>
    <TagCore
        v-else
        :text
        :variant
    />
</template>

<script setup lang="ts">
import type { TagCoreProps } from '@/components/design-system/tag/TagCore.vue';
import TagCore from '@/components/design-system/tag/TagCore.vue';
import DsTooltip from '@/components/design-system/tooltip/DsTooltip.vue';
import type { DsTooltipProps } from '@/components/design-system/tooltip/tooltip.types';

export interface DsTagProps extends TagCoreProps {
    tooltipText?: DsTooltipProps['tooltipText'];
}

defineProps<DsTagProps>();
</script>
